import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthenticationGuard } from '@app/core/authentication/authentication.guard';
import { IntegrationApiService } from '@app/core/service/api/integration.api.service';
import { UserApiService } from '@app/core/service/api/user.api.service';
import { ErrorMessageService } from '@app/core/service/error-message.service';
import { LocalStorageService } from '@app/core/service/local-storage.service';
import { AuthenticationService } from './authentication/authentication.service';
import { ManagerGuard } from './authentication/manager.guard';
import { ApiPrefixInterceptor } from './http/api-prefix.interceptor';
import { ErrorHandlerInterceptor } from './http/error-handler.interceptor';
import { AnnouncementApiService } from './service/api/announcement.api.service';
import { PsychologicalSurveyApiService } from './service/api/psychologicalSurvey.api.service';
import { TimezoneApiService } from './service/api/timezone.api.service';
import { HapticsService } from './service/haptics.service';
import { ToastService } from './service/toast.service';

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [],
  providers: [
    LocalStorageService,
    AuthenticationService,
    AuthenticationGuard,
    ManagerGuard,
    ApiPrefixInterceptor,
    ErrorHandlerInterceptor,
    UserApiService,
    AnnouncementApiService,
    PsychologicalSurveyApiService,
    ToastService,
    HapticsService,
    TimezoneApiService,
    IntegrationApiService,
    ErrorMessageService
  ]
})
export class CoreModule {}
